import { Checkbox } from "semantic-ui-react";
import { ConfirmBoxOptionsType } from "../../reducer/type";
import { Dispatch, SetStateAction } from "react";

type DRRestoreTypeProps = {
  options: ConfirmBoxOptionsType;
  setOptions: Dispatch<SetStateAction<ConfirmBoxOptionsType>>;
};

const DRRestoreType = ({ options, setOptions }: DRRestoreTypeProps) => {
  const onChange = () => {
    setOptions((prevOptions) => ({
      ...prevOptions,
      autostart: !options.autostart,
    }));
  };
  return (
    <Checkbox
      className="color-gray simple-checkbox margin-top margin-right-20"
      label="Automatically start server after restore is complete"
      checked={options.autostart}
      onChange={onChange}
    />
  );
};

export default DRRestoreType;
